import React, { useContext } from "react";
import pptpage from './Navigation_Guide_jupiter.pdf'
import DashboardMain_Jupiter from "../DashboardMain_Jupiter/DashboardMain_Jupiter";

function PPTPageDIC_Jupiter() {
  return (
    <>
      <DashboardMain_Jupiter>
        <iframe src={pptpage} style={{ marginTop: "7%" }} frameborder="0" height="500em" width="100%" sandbox></iframe>
      </DashboardMain_Jupiter>
    </>
  );
}

export default PPTPageDIC_Jupiter;